module.exports = __webpack_public_path__ + "static/media/img_panel_growth.b7119c1d.jpg";